import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  createUserAccount,
  createExternalUserAccount,
  getContentLatestVersion,
  getAssessmentByAssessmentId,
  createContentMap,
  verifyCapchaToken,
} from "./actions";
import { updateUserId } from "../login/actions";
import {
  fetchAbTest,
  getAbTest,
  getAssessmentResultByAssessmentAttemptId,
} from "../plan/actions";
import { isGuestOrPremiumUser } from "../settings/actions";
import {
  saveRelationshipCompatibilityResult,
  saveUserAssessmentResultMaps,
} from "../quiz/actions";
import { createGuestUserWithoutEmail } from "../confirmation/actions";
import SignupIQ from "./component";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createUserAccountConnect: createUserAccount,
      createExternalUserAccountConnect: createExternalUserAccount,
      updateUserIdConnect: updateUserId,
      getContentLatestVersionConnect: getContentLatestVersion,
      getAssessmentByAssessmentIdConnect: getAssessmentByAssessmentId,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      createContentMapConnect: createContentMap,
      isGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      saveRelationshipCompatibilityResultConnect:
        saveRelationshipCompatibilityResult,
      saveUserAssessmentResultMapsConnect: saveUserAssessmentResultMaps,
      createGuestUserWithoutEmailConnect: createGuestUserWithoutEmail,
      verifyCapchaConnect: verifyCapchaToken,
      getAbTestConnect: getAbTest,
      fetchAbTestConnect: fetchAbTest,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(SignupIQ);
